/*
 * RunIt flags — AOV kill switches for every visitor, experiment plumbing for consenting ones.
 * Plan and rules: docs/aov/EXPERIMENTS.md.
 *
 * Kill switches. Every AOV change renders by default. Turning the PostHog flag
 * `kill-aov-<name>` ON at 100% adds `rl-off-<name>` to <html> (assets/runit-aov.css hides the
 * change) on the next page load, for every visitor. The read is a configuration fetch, not
 * tracking: one fixed distinct_id shared by all visitors, no cookies, no storage, no personal
 * data, GeoIP off. If PostHog is slow or unreachable nothing is killed, so the store never
 * depends on it.
 *
 * Purchase attribution. Once a visitor has accepted analytics (`runit:posthog-ready`, fired by
 * assets/runit-consent.js), their PostHog distinct_id is written to the cart as the hidden
 * attribute `_ph_did`. The "PostHog checkout" custom pixel reads it at checkout_completed, so
 * a purchase joins the same visitor's page views and flag exposures. It is removed from the
 * cart when analytics consent is withdrawn; visitors who never consent never get one.
 *
 * Experiments. RunItFlags.variant(key) returns a consenting visitor's variant, or null (the
 * control) for everyone else — a visitor who declined cookies always sees the default.
 */
(function () {
  'use strict';

  var KEY = 'phc_vEkj6fFHmwBrrpzkH6Q36d7JdVUvpb4fiA6ud2av4jMC';
  var HOST = 'https://eu.i.posthog.com';
  var KILLS = {
    'kill-aov-pdp-companion': 'pdp-companion',
    'kill-aov-drawer-companion': 'drawer-companion',
    'kill-aov-reflective-delta': 'reflective-delta',
    'kill-aov-homepage-clearance': 'homepage-clearance',
    'kill-aov-kaching-style': 'kaching-style',
    'kill-aov-last-sizes-link': 'last-sizes-link'
  };
  var CART_ATTRIBUTE = '_ph_did';
  var killed = {};

  function kill(name) {
    killed[name] = true;
    document.documentElement.classList.add('rl-off-' + name);
    if (name === 'kaching-style') {
      var link = document.getElementById('rl-kaching-css');
      if (link) link.disabled = true;
    }
  }

  function flagOn(payload, key) {
    if (!payload) return false;
    if (payload.flags && payload.flags[key]) return payload.flags[key].enabled === true;
    if (payload.featureFlags) return payload.featureFlags[key] === true;
    return false;
  }

  function readKillSwitches() {
    if (typeof fetch !== 'function') return;
    try {
      fetch(HOST + '/flags/?v=2', {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          api_key: KEY,
          distinct_id: 'runit-storefront-config',
          geoip_disable: true,
          flag_keys_to_evaluate: Object.keys(KILLS)
        })
      })
        .then(function (response) {
          return response && response.ok ? response.json() : null;
        })
        .then(function (payload) {
          Object.keys(KILLS).forEach(function (key) {
            if (flagOn(payload, key)) kill(KILLS[key]);
          });
        })
        .catch(function () {
          /* PostHog unreachable: nothing is killed */
        });
    } catch (e) {
      /* never throw into the storefront */
    }
  }

  function analyticsOn() {
    var ph = window.posthog;
    if (window.__runitPosthogLoaded !== true || !ph || ph.__loaded !== true) return false;
    try {
      if (typeof ph.has_opted_out_capturing === 'function' && ph.has_opted_out_capturing()) return false;
    } catch (e) {
      return false;
    }
    return true;
  }

  function writeCartAttribute(value) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var current = (cart.attributes && cart.attributes[CART_ATTRIBUTE]) || '';
        if (current === (value || '')) return;
        var attributes = {};
        attributes[CART_ATTRIBUTE] = value || '';
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () {
        /* attribution is best effort; the cart must never notice */
      });
  }

  function linkCartToVisitor() {
    var tries = 0;
    (function wait() {
      if (analyticsOn()) {
        try {
          var id = window.posthog.get_distinct_id();
          if (id) writeCartAttribute(String(id));
        } catch (e) {
          /* ignore */
        }
        return;
      }
      tries += 1;
      if (tries < 40) setTimeout(wait, 250);
    })();
  }

  function variant(key) {
    if (!analyticsOn()) return null;
    try {
      var value = window.posthog.getFeatureFlag(key);
      return value == null || value === false ? null : value;
    } catch (e) {
      return null;
    }
  }

  window.RunItFlags = Object.freeze({
    killed: function (name) {
      return killed[name] === true;
    },
    variant: variant
  });

  readKillSwitches();
  document.addEventListener('runit:posthog-ready', linkCartToVisitor);
  if (window.__runitPosthogLoaded === true) linkCartToVisitor();
  document.addEventListener('visitorConsentCollected', function (event) {
    try {
      if (event && event.detail && event.detail.analyticsAllowed === false) writeCartAttribute('');
    } catch (e) {
      /* ignore */
    }
  });
})();
